import API from "@/config/api";
import axios from "axios";

export const GET_PARENT_STUDENTS = (params = {}) =>
  axios.get(API.parent.students.all, { params });

export const GET_CHILD = (payload) =>
  axios.get(API.parent.students.one.replace("$person_id", payload.childId));

export const BLOCK_CARD = (payload) =>
  axios.delete(API.parent.cards.one.replace("$id", payload.id), {
    data: payload.data,
  });

export const UNLOCK_CARD = (payload) =>
  axios.delete(API.parent.cards.one.replace("$id", payload.id), {
    data: payload.data,
  });

export const UPDATE_STUDENT = (chidlId, data) =>
  axios.patch(API.parent.students.one.replace("$person_id", chidlId), data);

export const GET_PAYER_INFO = (payload) =>
  axios.get(API.parent.payer.info.replace("$person_id", payload.childId));

export const GET_PAYER_TARIFFS = (childId) =>
  axios.get(API.parent.payer.tariffs.replace("$person_id", childId));

export const SET_CURRENT_TARIFF = ({ childId, id }) =>
  axios.post(
    API.parent.payer.setCurrent
      .replace("$person_id", childId)
      .replace("$id", id)
  );

export const SET_NEXT_TARIFF = ({ childId, id }) =>
  axios.post(
    API.parent.payer.setNext.replace("$person_id", childId).replace("$id", id)
  );

export const PAUSE_CURRENT_TARIFF = ({ childId, data }) =>
  axios.post(API.parent.payer.pause.replace("$person_id", childId), { data });

export const UNPAUSE_CURRENT_TARIFF = ({ childId, data }) =>
  axios.post(API.parent.payer.unpause.replace("$person_id", childId), { data });

export const CREATE_PAYMENT = ({ childId, amount }) =>
  axios.post(
    API.parent.payments.create
      .replace("$amount", amount)
      .replace("$person_id", childId)
  );

export const GET_CHILD_NOTIFICATIONS = (childId, params = {}) =>
  axios.get(API.parent.notifications.all.replace("$person_id", childId), {
    params,
  });

export const READ_CHILD_NOTIFICATION = (id, childId) =>
  axios.put(
    API.parent.notifications.read
      .replace("$person_id", childId)
      .replace("$id", id)
  );

export const GET_BALANCE_HISTORY = (childId, params = {}) =>
  axios.get(API.parent.balance.history.replace("$person_id", childId), {
    params,
  });

export const GET_NOTIFICATION_SETTINGS = (childId, payload) =>
  axios.get(
    API.parent.notifications.settings.replace("$person_id", childId),
    payload
  );

export const UPDATE_NOTIFICATION_SETTINGS = (childId, payload) =>
  axios.patch(
    API.parent.notifications.settings.replace("$person_id", childId),
    payload
  );

export const GET_CHILD_PASSAGES = (childId, params = {}) =>
  axios.get(API.parent.passages.all.replace("$person_id", childId), { params });

export const GET_AGREEMENT_TEXT = (params = {}) =>
  axios.get(API.parent.agreement.current, { params });

export const GET_SUPPORT_CONTACTS = (params = {}) =>
  axios.get(API.parent.support.contacts, { params });

export const SEND_SUPPORT_MESSAGE = (childId, data) =>
  axios.post(API.parent.support.message.replace("$person_id", childId), data);

export const REQUEST_REPORT_BALANCE_HISTORY = (params) =>
  axios.post(
    API.parent.reports.balance_history.replace("$person_id", params.childId),
    { ...params }
  );

export const REQUEST_REPORT_PASSAGES = (params) =>
  axios.post(
    API.parent.reports.passages.replace("$person_id", params.childId),
    { ...params }
  );

export const GET_REPORT_STATUS = (guid) =>
  axios.get(API.parent.reports.status.replace("$guid", guid));

export const DOWNLOAD_REPORT = (guid) =>
  axios.get(API.parent.reports.download.replace("$guid", guid));
